module.exports = __webpack_public_path__ + "img/empty.fce5e599.svg";